import axios from "axios";

// Live backend switch:
// Set REACT_APP_API_BASE_URL to your production API origin (e.g. https://api.betterdays.app)
// to point the whole web app at the live mobile backend. Leave it empty to use the
// bundled/local backend served via REACT_APP_BACKEND_URL.
const OVERRIDE = (process.env.REACT_APP_API_BASE_URL || "").trim();
// The browser calls the mobile backend DIRECTLY (client-side). Server-side origin->origin
// egress to the mobile preview host is unreliable inside the cluster, so we do NOT proxy.
// The mobile backend is a fixed external endpoint; hardcoded as a deploy-proof default.
const LIVE_DEFAULT = "https://fitpulse-tracker-27.emergent.host";
const BASE = (OVERRIDE || LIVE_DEFAULT).replace(/\/+$/, "");
export const API = `${BASE}/api`;
export const USING_LIVE_BACKEND = true;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Tolerant extractors so we work with either the local stand-in or the live backend,
// regardless of whether it returns { token } / { access_token } / { accessToken }.
export function extractToken(data) {
  return data?.session_token || data?.token || data?.access_token || data?.accessToken || data?.jwt || null;
}
export function extractUser(data) {
  return data?.user || data?.profile || data?.me || data || null;
}

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
